"use strict";

(() => {

    $(document).on('click', '.js__toggle-subscribe-notifications', (e) => {

        if ($(e.currentTarget).attr('data-action') === 'subscribe') {

            let button = $(e.currentTarget);

            axios.post('/api/internal/events/toggle-notifications', {
                user_id: USER_ID,
                event_id: EVENT_ID,
            }).then((response) => {
                $(button).children().closest('.icon').removeClass('ni-bell-off');
                $(button).children().closest('.icon').addClass('ni-bell');
                $(button).attr('data-action', 'unsubscribe');
                $(button).attr('data-original-title', response.data);
            }).catch((errors) => {
                console.log(errors);
            });

        } else {

            let button = $(e.currentTarget);

            axios.post('/api/internal/events/toggle-notifications', {
                user_id: USER_ID,
                event_id: EVENT_ID,
            }).then((response) => {
                $(button).children().closest('.icon').removeClass('ni-bell');
                $(button).children().closest('.icon').addClass('ni-bell-off');
                $(button).attr('data-action', 'subscribe');
                $(button).attr('data-original-title', response.data);
            }).catch((errors) => {
                console.log(errors);
            });
        }
    });

    /**
     * Map style
     */
    if (LOAD_MAP) {
        mapboxgl.accessToken = process.env.MIX_MAPBOX_TOKEN;
        let style = 'navigation-guidance-day-v4';

        if (getCookie('darkMode') !== "") {
            if (getCookie('darkMode') === 'true') {
                style = 'navigation-guidance-night-v4';
            } else {
                style = 'navigation-guidance-day-v4';
            }
        }

        let map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/' + style, // stylesheet location
            center: [LOCATION_LNG, LOCATION_LAT], // starting position [lng, lat]
            zoom: 12 // starting zoom
        });

        let marker = new mapboxgl.Marker({
            color: "#666666",
            draggable: false
        }).setLngLat([LOCATION_LNG, LOCATION_LAT])
            .setPopup(new mapboxgl.Popup().setHTML('<p>' + LOCATION_ADDRESS + '</p>')) // add popup
            .addTo(map);

        marker.togglePopup();

        let nav = new mapboxgl.NavigationControl();
        map.addControl(nav, 'top-right');

        $(document).on('changeMapStyle', (e) => {
            if (getCookie('darkMode') === 'true') {
                style = 'navigation-guidance-night-v4';
            } else {
                style = 'navigation-guidance-day-v4';
            }
            map.setStyle('mapbox://styles/mapbox/' + style);
        });
    }

})();
